<template>
  <div class="media-upload">
    <el-upload action="#" :accept="accept" :show-file-list="false" :disabled="uploading"
      :before-upload="beforeUpload" :http-request="uploadFile">
      <el-button size="small" type="primary" plain :loading="uploading">{{ uploading ? '上传中 ' + progress + '%' : uploadLabel }}</el-button>
    </el-upload>
    <el-button v-if="uploading" type="text" size="small" @click="cancelUpload">取消上传</el-button>
    <p class="upload-hint" v-if="type === 'POLICY'">支持 Word、Excel、PPT、PDF，单个文件不超过 20 GB，最多 20 个</p>
    <p class="upload-hint" v-else-if="type === 'TEMPLATE'">支持 Word、Excel、PPT、PDF 和 JPG、PNG、GIF、WebP 图片，每个模板可添加 1 至 8 个文件，单文件最大 200 MB</p>
    <p class="upload-hint" v-else>支持 JPG、PNG、GIF、WebP 图片（10 MB 内）及 MP4 视频（单文件 20 GB 内），最多 20 个</p>
    <div v-for="item in attachments" :key="item.url" class="media-row">
      <img v-if="item.kind === 'IMAGE'" :src="item.url" alt="图片缩略图" />
      <i v-else :class="item.kind === 'VIDEO' ? 'el-icon-video-camera' : 'el-icon-document'" />
      <a :href="item.url" target="_blank" rel="noopener noreferrer" :title="item.name">{{ item.name }}</a>
      <span>{{ size(item.size) }}{{ item.kind === 'VIDEO' ? ' · ' + item.durationSeconds + '秒' : '' }}</span>
      <el-button type="text" class="remove" :disabled="uploading" @click.stop="remove(item.url)">移除</el-button>
    </div>
  </div>
</template>

<script>
import { uploadWorkbenchMedia, imageExtensions, documentExtensions } from './workbenchUpload'
export default {
  name: 'WorkbenchMediaUpload',
  props: { value: { type: Array, default: () => [] }, type: { type: String, required: true } },
  data() { return { uploading: false, progress: 0, uploadController: null, disposed: false } },
  beforeDestroy() { this.disposed = true; this.cancelUpload() },
  computed: {
    attachments() { return this.value.filter(item => !item.inline) },
    accept() { return this.type === 'POLICY' ? '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf' : this.type === 'TEMPLATE' ? '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.jpg,.jpeg,.png,.gif,.webp' : '.jpg,.jpeg,.png,.gif,.webp,.mp4' },
    uploadLabel() { return this.type === 'TEMPLATE' ? '添加模板文件' : '上传' + (this.type === 'POLICY' ? '文档' : '图片或视频') }
  },
  methods: {
    cancelUpload() { if (this.uploadController) this.uploadController.abort() },
    size(bytes) { return Number(bytes) >= 1073741824 ? (Number(bytes) / 1073741824).toFixed(2) + ' GB' : Number(bytes) >= 1048576 ? (Number(bytes) / 1048576).toFixed(1) + ' MB' : Math.ceil(Number(bytes) / 1024) + ' KB' },
    remove(url) { this.$emit('input', this.value.filter(item => item.url !== url)) },
    beforeUpload() {
      const max = this.type === 'TEMPLATE' ? 8 : 20
      if (this.value.length >= max) { this.$message.warning(this.type === 'TEMPLATE' ? '每个模板最多添加8个文件，请先移除不需要的文件' : '正文和附件合计最多20个文件'); return false }
      return true
    },
    async uploadFile(request) {
      this.uploading = true; this.$emit('uploading', true)
      const controller = new AbortController(); this.uploadController = controller
      try {
        const media = await uploadWorkbenchMedia(this.axios, request.file,
          this.type === 'POLICY' ? documentExtensions : this.type === 'TEMPLATE' ? [...documentExtensions, ...imageExtensions] : [...imageExtensions, 'mp4'],
          value => { this.progress = value }, this.type, { signal: controller.signal })
        if (this.disposed) return
        this.$emit('input', [...this.value, media])
        request.onSuccess && request.onSuccess({})
      } catch (error) { if (!this.disposed) { request.onError && request.onError(error); this.$message[error.cancelled ? 'info' : 'error'](error.message || '上传失败') } }
      finally { this.uploadController = null; this.uploading = false; this.progress = 0; if (!this.disposed) this.$emit('uploading', false) }
    }
  }
}
</script>

<style scoped>
.upload-hint{margin:8px 0 12px;color:#909399;font-size:12px;line-height:1.5}.media-row{display:flex;align-items:center;gap:10px;padding:8px 0;border-bottom:1px solid #ebeef5}.media-row img{width:40px;height:40px;object-fit:cover;border-radius:4px}.media-row i{font-size:24px;color:#409eff}.media-row a{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:#409eff}.media-row span{color:#909399;font-size:12px;white-space:nowrap}.media-row .remove{color:#f56c6c}
</style>
